<template>
  <div>
    <button :id="dropdownId" :class="titleClass"
            :data-dropdown-placement="placement"
            :data-dropdown-toggle="dropdownContentId"
            class="text-center inline-flex items-center"
            type="button"><i v-if="leftIconClass" :class="leftIconClass" class="ml-2"></i> {{ title }}
      <i v-if="iconClass" :class="iconClass" class="ml-1"></i>
    </button>

    <!-- Dropdown menu -->
    <div :id="dropdownContentId"
         :class="containerClass"
         class="hidden z-10 w-44 bg-white rounded divide-y divide-gray-100 ring-1 ring-black ring-opacity-5 rounded-md shadow-lg bg-white">
      <ul :aria-labelledby="dropdownId" class="py-1 text-sm text-gray-700">
        <li v-for="(item, index) in items" :key="index">
          <a :class="itemClass"
             class="block py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
             @click="onItemClick(item)">
            <img :src="item.imageUrl" class="inline" style="height: 24px" v-if="item.imageUrl" alt=""/>
            {{ item.text }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import {initDropdown} from "@/components/dropdown/index";
import {randomStr} from "@/helpers/helpers";

export default {
  name: "DropDown",
  props: {
    value: [String, Number, Array, Object],
    title: String,
    titleClass: [String, Number, Array, Object],
    itemClass: [String, Number, Array, Object],
    containerClass: [String, Number, Array, Object],
    items: Array,
    iconClass: String,
    placement: {
      type: String,
      default: "bottom"
    },
    leftIconClass: String,
  },
  computed: {
    dropdownId() {
      return `dropdown-${ randomStr() }`
    },
    dropdownContentId() {
      return `dropdown-content-${ randomStr() }`
    },
  },
  methods: {
    onItemClick(item) {
      if (item.onClick) {
        item.onClick();
      }

      if (item.id) {
        this.$emit("input", item.id);
        this.$emit("onSelect", item.id);
      }
    }
  },
  mounted() {
    initDropdown({id: this.dropdownId});
  }
}
</script>

<style scoped>

</style>
